module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container_com-fundo card-dados card-dados_proponente"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-media"
  }, [_vm._v("\n    Dados do proponente\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "conteudo-proponentes"
  }, _vm._l((_vm.proponentes), function(proponente, index) {
    return _c('div', {
      key: 'proponente-' + index
    }, [_c('proponente-item', {
      attrs: {
        "proponente": proponente,
        "ordem": index + 1
      }
    }), _vm._v(" "), (index < _vm.proponentes.length - 1) ? _c('hr', {
      staticClass: "separador-proponentes"
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados_resumo-renda"
  }, [_c('span', {
    staticClass: "item-de-dado_resumo"
  }, [_vm._v("\n      Renda familiar apurada: " + _vm._s(_vm.rendaTotalComprovada || "NÃO INFORMADO") + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado_resumo"
  }, [_vm._v("\n      Somatório de renda: " + _vm._s(_vm.rendaTotal || "NÃO INFORMADO") + "\n    ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28a0086e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28a0086e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/DadosDoProponente.vue
// module id = 1101
// module chunks = 1